<template>
  <v-dialog v-model="internalValue" max-width="560px" persistent scrollable>
    <v-card class="ds-dialog">
      <v-card-title class="ds-dialog-header">
        <v-icon color="white" class="mr-2" style="position: relative; z-index: 1">
          {{ typeIcon }}
        </v-icon>
        <span class="ds-dialog-title">Diagnósticos (CID) do item</span>
        <v-spacer></v-spacer>
        <v-btn icon class="close-btn" color="white" @click="handleCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="ds-dialog-body">
        <section class="ds-form-section">
          <v-alert type="info" text dense class="mb-4">
            <strong>{{ item?.name }}</strong>
            <span v-if="item?.tuss_code"> · TUSS {{ item.tuss_code }}</span>
          </v-alert>

          <p class="text-caption text--secondary mb-2">
            Selecione o(s) CID(s) deste {{ typeLabelSingular }} — eles serão salvos
            junto com a prescrição.
          </p>

          <PatientCidSelector
            v-if="patientId"
            v-model="selectedCidIds"
            :patient-id="patientId"
          />
        </section>
      </v-card-text>

      <v-card-actions class="ds-dialog-actions">
        <v-btn outlined color="primary" @click="handleCancel">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" depressed @click="handleConfirm">
          Adicionar à prescrição
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PatientCidSelector from "@/features/patients/prescriptions/components/PatientCidSelector.vue";

export default {
  name: "ItemCidConfirmDialog",

  components: { PatientCidSelector },

  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: null },
    patientId: { type: [String, Number], default: null },
    prescriptionType: { type: String, default: "exam" },
  },

  data() {
    return {
      selectedCidIds: [],
    };
  },

  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    typeIcon() {
      return (
        { exam: "mdi-test-tube", supplement: "mdi-leaf", medication: "mdi-pill" }[
          this.prescriptionType
        ] || "mdi-clipboard-list-outline"
      );
    },
    typeLabelSingular() {
      return (
        { exam: "exame", supplement: "suplemento", medication: "medicamento" }[
          this.prescriptionType
        ] || "item"
      );
    },
  },

  watch: {
    value(open) {
      if (open) this.selectedCidIds = [];
    },
  },

  methods: {
    handleCancel() {
      this.$emit("cancel");
      this.$emit("input", false);
    },
    handleConfirm() {
      this.$emit("confirm", [...this.selectedCidIds]);
      this.$emit("input", false);
    },
  },
};
</script>

<style scoped>
.ds-dialog {
  border-radius: 4px !important;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(31, 77, 63, 0.18),
    0 4px 12px rgba(0, 0, 0, 0.06) !important;
}
.close-btn {
  position: relative;
  z-index: 1;
}
.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
}
</style>
